import { mount } from 'svelte';
import './app.css';
import App from './App.svelte';

if (import.meta.env.MODE === 'e2e') void import('./lib/testHooks').then((m) => m.install());

export default mount(App, { target: document.getElementById('app')! });
